import { is } from 'ramda'
import type { CustomEventsContext } from '../types'

const TIMEOUT = 60 * 1000 // 60 minutes in ms

// data structure: { version: int | undefined, subscription_params: { receipt: Base64 string, signature: Base64 string } }

export default function (this: CustomEventsContext, googleId: string, params: Record<string, unknown>) {
  return this.sendEventWithCallback(
    'subscription.buy.android',
    {
      google_id: googleId,
      ...params,
    },
    TIMEOUT
  ).then((data: unknown) => {
    const d = data as { subscription_params?: unknown }
    if (is(Object, d.subscription_params)) {
      return data
    }
    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
